import React from 'react'
import style from './style.module.css'
import { Link, NavLink } from "react-router-dom";
import { Facebook, Instagram, X } from '../../assets';

export const Footer = () => {
    return (
        <footer>
            <div>
                <h4>Quick Links</h4>
                <NavLink
                    to="/"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Home
                </NavLink>
                <NavLink
                    to="/about-us"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    About Us
                </NavLink>
                <NavLink
                    to="/contact-us"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Contact Us
                </NavLink>
                {/* <NavLink
                    to="#"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Services
                </NavLink> */}
            </div>

            <div>
                <h4>Extra</h4>
                {/* <NavLink
                    to="#"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Privacy Policy
                </NavLink> */}
                {/* <NavLink
                    to="#"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Terms and Condition
                </NavLink> */}
                <NavLink
                    to="https://irs.en.gov.ng/enugutccverification"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    TCC verification
                </NavLink>
                <NavLink
                    to="https://jtb.gov.ng"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    TIN Registration and Enquiries
                </NavLink>
                <NavLink
                    to="https://irs.en.gov.ng/"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    Enugu IRS website
                </NavLink>
            </div>

            <div>
                <h4>Enugu Office</h4>
                <p className={style.address}>
                    Plot O, Trinity House, Apartment B, Fidelity Estate, Okpara Avenue, Enugu
                </p>
            </div>
            <div>
                <h4>Connect with us</h4>
                <div className={style.socials}>
                    <Link to={'https://www.facebook.com/profile.php?id=61559661552725&mibextid=ZbWKwL'}>
                        <Facebook />
                    </Link>
                    <Link to={'https://www.instagram.com/esrs_norlics?igsh=MXBqeHBqaWpsNmZlbg=='}>
                        <Instagram />
                    </Link>
                    <Link to={'https://x.com/norlics20125?t=znPcwZO1HqQJShP-L3mPGA&s=09'}>
                        <X />
                    </Link>
                </div>
                <NavLink
                    to="#"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                >
                    +2347063162705
                </NavLink>
                <a
                    href="mailto: norlics@norlics.com.ng"
                    className={style.email}
                >
                    norlics@norlics.com.ng
                </a>
            </div>

        </footer>
    )
}
